/**
 * The `/glossary` page's entry point — the theme toggle, and nothing else.
 *
 * This page is a static document: `build/glossary-page.ts` writes every
 * definition into the HTML at build time precisely so the page works with no
 * JavaScript at all, which is the condition its whole reason for existing
 * depends on. Nothing here changes that. The content is already on screen
 * before this file is fetched, and if it never arrives the page is complete.
 *
 * What it buys is that the header is the same header on both documents: same
 * two nav items, same control, same order (owner ruling, 2026-08-07). A theme
 * toggle that exists on one page of a two-page site and not the other reads as
 * a bug in the page that lacks it.
 *
 * Separate from `main.ts` on purpose — see the comment on the `<script>` tag in
 * `glossary.html`. That module builds and mounts the entire tool and throws if
 * `#app` is absent, which it is here.
 */

// No stylesheet imports, deliberately: `glossary.html` links both files itself,
// and importing them here as well would emit a second copy of the CSS behind
// this chunk and make the page's styles wait on a script.
import { mountThemeToggle } from "./ui/theme.js";

const toggle = document.querySelector<HTMLButtonElement>("#theme-toggle");

// Soft failure, unlike the app's shell check. A missing button on a page whose
// job is to be readable is not worth an uncaught exception in the console of
// every visitor; the definitions above it are unaffected either way.
if (toggle) {
  // Also unhides it — the button ships `hidden` so a reader who never runs this
  // script sees no control rather than a dead one. See `mountThemeToggle`.
  mountThemeToggle(toggle);
}
